import axios from "axios";

export const deleteEmployee = async (deleteData) => {
  const data = JSON.stringify(deleteData);
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';

  const config = {
    method: "POST",
    url: `http://${url}:4000/api/v1/boletaDigital/deleteEmployee`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = axios(config);
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
